// extracted by mini-css-extract-plugin
export default {"mainContainer":"Reports_mainContainer__c6x3J"};